import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const CHART_GRANULARITIES = [
  { key: "day", label: "روزانه" },
  { key: "week", label: "هفتگی" },
  { key: "month", label: "ماهانه" },
  { key: "year", label: "سالانه" },
];

const DashboardCharts = ({
  incomeTrend,
  incomeGranularity,
  handleIncomeGranularityChange,
  weeklyActivity,
  CustomTooltip,
}) => (
  <div className="charts-grid">
    <div className="chart-card">
      <div className="chart-header">
        <div>
          <h3 className="chart-title">درآمد ماهانه</h3>
          <p className="chart-subtitle">نمایش درآمد بر اساس بازه زمانی</p>
          <div className="income-granularity-tabs">
            {CHART_GRANULARITIES.map((item) => (
              <button
                key={item.key}
                className={`income-tab-button ${
                  incomeGranularity === item.key ? "active" : ""
                }`}
                onClick={() => handleIncomeGranularityChange(item.key)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={incomeTrend}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="label" tick={{ fontFamily: "MyPersianFont, iran-sans" }} />
          <YAxis tick={{ fontFamily: "MyPersianFont, iran-sans" }} />
          <Tooltip content={<CustomTooltip isCurrency={true} />} />
          <Bar dataKey="amount" fill="url(#colorRevenue)" radius={[8, 8, 0, 0]} />
          <defs>
            <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#7cc890" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#7cc890" stopOpacity={0.3} />
            </linearGradient>
          </defs>
        </BarChart>
      </ResponsiveContainer>
    </div>

    <div className="chart-card">
      <div className="chart-header">
        <div>
          <h3 className="chart-title">فعالیت هفتگی</h3>
          <p className="chart-subtitle">مشاوره‌ها و رزروها در ۴ هفته اخیر</p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={weeklyActivity}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="weekLabel"
            tick={{ fontFamily: "MyPersianFont, iran-sans" }}
          />
          <YAxis tick={{ fontFamily: "MyPersianFont, iran-sans" }} />
          <Tooltip content={<CustomTooltip isCurrency={false} />} />
          <Legend wrapperStyle={{ fontFamily: "MyPersianFont, iran-sans" }} />
          <Line
            type="monotone"
            dataKey="consultationsCount"
            name="مشاوره‌ها"
            stroke="#7cc890"
            strokeWidth={3}
            dot={{ fill: "#7cc890", r: 5 }}
            activeDot={{ r: 7 }}
          />
          <Line
            type="monotone"
            dataKey="reservationsCount"
            name="رزروها"
            stroke="#0d6efd"
            strokeWidth={3}
            dot={{ fill: "#0d6efd", r: 5 }}
            activeDot={{ r: 7 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default DashboardCharts;
